import script from "./PieChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./PieChart.vue?vue&type=script&lang=ts&setup=true"

import "./PieChart.vue?vue&type=style&index=0&id=99bc4f22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99bc4f22"]])

export default __exports__